module.exports = __webpack_public_path__ + "img/2_nike.b8cb3bfa.jpg";